module.exports = __webpack_public_path__ + "media/status-running.0b549999.svg";